<template>
  <div v-title data-title="活动结束">
    <section class="sm2-bg">
        <p>感恩节回馈活动已经结束啦！<br />感谢您的参与</p>
        <img src="../../assets/img/erweima.png" class="ewm" />
        <p>关注【壹选生活】<br />查看更多优质产品</p>
    </section>
  </div>
</template>

<script>
export default {
  name: "activityends",
  data: function() {},
  methods: {}
};
</script>




// WEBPACK FOOTER //
// src/components/fissionactivity/activityends.vue